module.exports = __webpack_public_path__ + "5e3021a49f277b7c67daa76d8b53c9ed.png";